"use strict";
var reduce_1 = require('./reduce');
function toArrayReducer(arr, item, index) {
    arr.push(item);
    return arr;
}
function toArray() {
    return reduce_1.reduce(toArrayReducer, []);
}
exports.toArray = toArray;
//# sourceMappingURL=toArray.js.map


//////////////////
// WEBPACK FOOTER
// C:/Works/Respite/respite_app/UI/~/rxjs/operators/toArray.js
// module id = ../../../../rxjs/operators/toArray.js
// module chunks = 4